var map = {
	"./IMG_1_VIDEO.mp4": 7691,
	"./IMG_24_VIDEO.mp4": 4474,
	"./IMG_29_VIDEO.mp4": 1203,
	"./IMG_8_VIDEO.mp4": 5382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6352;